import {LOCATION_CHANGE, push} from 'connected-react-router';
import qs from 'query-string';
import * as LoginActions from '../actions/LoginActions';
import * as RoutesConstant from '../constants/RoutesConstant';

export const SSOMiddleware = (store: any) => (next: any) => (action: any) => {
    if (action.type === LOCATION_CHANGE && action.payload.location && action.payload.location.pathname) {
        if (RoutesConstant.SSO_TOKEN_PATH === action.payload.location.pathname) {
            if (action.payload.location.search) {
                const queryStrings = qs.parse(action.payload.location.search);
                if (queryStrings.code && queryStrings.state) {
                    return store.dispatch(LoginActions.SSO_GET_TOKEN_BY_CODE.action(queryStrings.code));
                }
            } else {
                const {login: {pathToRedirect}} = store.getState();
                if (pathToRedirect === null || pathToRedirect === '') {
                    return store.dispatch(push(RoutesConstant.CALCULATOR_PATH));
                }
                return store.dispatch(push(pathToRedirect));
            }
        }
    }
    return next(action);
};
